var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn btn-light btn-sm pointer",staticStyle:{"border-radius":"0 .2rem .2rem 0"},on:{"click":_vm.toggle}},[_c('font-awesome-icon',{attrs:{"icon":['fas', _vm.screen ? 'angle-double-left' : 'angle-double-right']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }